// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2113":"9d052ca9","2918":"9d052ca9","4279":"9d052ca9","8670":"9d052ca9","8766":"9d052ca9","8942":"9d052ca9","9742":"9d052ca9"}[chunkId] + ".chunk.css";
};